<template>
  <select
    id="locale-select"
    v-model="$i18n.locale"
    @change="saveLocale"
    ref="localeSelect">
    <option v-for="(lang, i) in languages" :key="`Lang${i}`" :value="lang.code">{{ lang.name }}</option>
  </select>
</template>

<script>
import localStore from 'store'

export default {
  name: 'language-switcher',
  data () {
    return {
      languages: [
        { code: 'en', name: 'English' },
        { code: 'de', name: 'Deutsche' },
        { code: 'es', name: 'Español' },
        { code: 'fr', name: 'Français' },
        { code: 'nl', name: 'Nederlands' },
        { code: 'pt', name: 'Português' }
      ]
    }
  },
  methods: {
    saveLocale () {
      localStore.set('language', this.$refs.localeSelect.value)
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-button-default: $color-cta-dark
  $color-button-default-hover: $color-cta
  $color-button-cta: $color-cta
  $color-button-cta-hover: $color-cta-dark
  $color-button-disabled: $signable-secondary-4-shade-3
  $color-button-disabled-dark: $signable-secondary-4-shade-1
  $color-button-inverted: #fff
  $color-button-inverted-dark: $color-grey-light
  .button
    padding: 12px $spacing-base
    background-color: #fff
    color: $color-button-default
    float: left
    font-weight: bold
    text-decoration: none
    border: 1px solid $color-button-default
    border-radius: 3px
    &:hover
      background-color: $color-button-default
      color: #fff
    &--cta
      background-color: $color-button-cta
      border-color: $color-button-cta
      color: #fff
      &:hover
        background-color: $color-button-cta-hover
        border-color: $color-button-cta-hover
    &--disabled
      background-color: $color-button-disabled
      color: $color-button-disabled-dark
      border-color: $color-button-disabled-dark
      cursor: not-allowed
      pointer-events: none
      &:hover
        background-color: $color-button-disabled
        color: $color-button-disabled-dark
    &--inverted
      background-color: $color-button-inverted
      color: #000
      &:hover
        background-color: $color-button-inverted-dark
    &--mini
      padding: $spacing-xs $spacing-small
    svg,
    span
      pointer-events: none
    svg
      float: left
</style>
